import { useRef, useState } from 'react'
import { track } from '../../lib/analytics'

/** A feltolto ELFOGAD kiterjesztesei. A ZIP is ide tartozik. */
export const ACCEPT_ATTR = '.stl,.obj,.3mf,.zip'

/**
 * A FELTOLTO.
 *
 * Egyetlen, hangsulyos terulet: kattints, vagy - asztali gepen - huzd ide.
 * Ugyanez all a fooldalon es az arbecsles-oldalon.
 *
 * BILLENTYUZETTEL IS HASZNALHATO: a terulet `button`, tehat Tabbal
 * elerheto, Enterrel es szokozzel is aktivalhato (a bongeszo maga kezeli
 * a szokozt a gombokon).
 *
 * ────────────────────────────────────────────────────────────────────
 * KET MEROPONT, ES MIERT KETTO
 *
 * `upload_cta_clicked`  a latogato AKTIVALTA a feltoltot (kattintas vagy
 *                       billentyu). Huzas-ejtesnel NEM indul el - ott
 *                       nincs mit megnyitni.
 * `file_picker_opened`  tenylegesen megnyilt a rendszer fajlvalasztoja.
 *
 * A ketto kozotti kulonbseg nem elmeleti: ha a rejtett `input` barmiert
 * nincs a DOM-ban, az elso elmegy, a masodik nem - es a meresben latszik,
 * hogy a kattintas nem vezetett sehova. A huzas-ejtes pedig mindkettot
 * kihagyja, tehat a ketto es a `file_chosen_raw` aranya azt is megmondja,
 * hanyan huzzak be a fajlt ahelyett, hogy tallozananak.
 * ────────────────────────────────────────────────────────────────────
 */
export default function FileDrop({
  onFiles,
  title,
  hint,
  note,
  dragNote,
  place,
  action,
  compact = false,
  block = 'drop'
}: {
  onFiles: (files: File[]) => void
  title: string
  hint: string
  /**
   * Masodik, halvanyabb sor a jelzes alatt. Itt all az, ami a KOCKAZATOT
   * veszi el („Nem indit rendelest…") - ezert nem a `hint`-be tomoritjuk:
   * a formatumlista es a megnyugtatas ket kulon dolog.
   */
  note?: string
  /**
   * CSAK ASZTALI GEPEN latszo sor (a `${block}__drag` osztalyt a stiluslap
   * rejti el keskeny kepernyon).
   *
   * MOBILON A HUZAS NEM ERTELMEZHETO: nincs mit honnan hova huzni. Amig ez
   * volt az elsodleges utasitas („Huzd ide a kesz 3D fajlokat"), a mobil
   * latogato egy olyan mondatot kapott elso valaszkent, amit nem tudott
   * vegrehajtani.
   */
  dragNote?: string
  /** A lap, ahonnan a feltolto indult - a meresbe megy (`fooldal`, `arbecsles`). */
  place?: string
  /**
   * LATHATO GOMBFELIRAT A TERULET SZELEN („Fájl kiválasztása").
   *
   * NEM kulon `<button>`: az egesz terulet mar gomb (`role="button"`), es
   * gombot gombba agyazni ervenytelen - a kepernyoolvaso ket celpontot
   * jelentene ugyanarra a muveletre. Ez csak a vizualis jel, hogy a teruletre
   * KATTINTANI is lehet, nem csak huzni; ezert `aria-hidden`.
   */
  action?: string
  compact?: boolean
  /*
    A BLOKKNEV HIVASI HELYENKENT MAS.

    A fooldalon `drop` (a `styles/home.css` adja a megjelenest), az
    arbecslesben `estimate-drop` (a `styles/estimate.css` sajat
    nevterebol). Egy kozos osztalynev a ket helyen ket kulon
    stiluslapbol kapna meretet - pontosan azt a kaszkad-utkozest, amit
    meg akarunk szuntetni.
  */
  block?: string
}): JSX.Element {
  const inputRef = useRef<HTMLInputElement>(null)
  const [dragging, setDragging] = useState(false)

  const handle = (list: FileList | null): void => {
    if (!list?.length) return
    onFiles([...list])
  }

  /** Kattintas vagy billentyu: meres, majd a fajlvalaszto megnyitasa. */
  const aktival = (): void => {
    track('upload_cta_clicked', { place: place ?? block })
    if (!inputRef.current) return
    inputRef.current.click()
    track('file_picker_opened', { place: place ?? block })
  }

  return (
    <div
      className={`${block}${dragging ? ' is-drag' : ''}${compact ? ` ${block}--compact` : ''}`}
      role="button"
      tabIndex={0}
      onClick={aktival}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          aktival()
        }
      }}
      onDragOver={(e) => {
        e.preventDefault()
        setDragging(true)
      }}
      onDragLeave={() => setDragging(false)}
      onDrop={(e) => {
        e.preventDefault()
        setDragging(false)
        handle(e.dataTransfer.files)
      }}
    >
      <input
        ref={inputRef}
        type="file"
        multiple
        accept={ACCEPT_ATTR}
        hidden
        onChange={(e) => {
          handle(e.target.files)
          // Ugyanaz a fajl ujra valaszthato legyen.
          e.target.value = ''
        }}
      />
      <strong className={`${block}__title`}>{title}</strong>
      <span className={`${block}__hint`}>{hint}</span>
      {note && <span className={`${block}__note`}>{note}</span>}
      {dragNote && <span className={`${block}__drag`}>{dragNote}</span>}
      {action && (
        <span className={`${block}__action`} aria-hidden="true">
          {action}
        </span>
      )}
    </div>
  )
}
